import { Injectable } from '@angular/core';
import { PermissionType } from 'src/app/shared/models/permission-type.model';
import { PermissionView } from '../../models/permission-type.model';
import { ResolverService } from '../resolver/resolver.service';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  constructor(
    private resolverService: ResolverService
  ) { }

  get isAccountant() {
    return this.resolverService.userInitInfo.merchant_detail.accountant;
  }

  get isDigitalSeller() {
    return this.resolverService.userInitInfo.merchant_detail.seller_digital;
  }

  get isPhysicalSeller() {
    return this.resolverService.userInitInfo.merchant_detail.seller_physical;
  }

  get isCryptoSeller() {
    return this.resolverService.userInitInfo.merchant_detail.seller_crypto;
  }

  get isAdmin() {
    return this.resolverService.userInitInfo.merchant_detail.admin;
  }

  get isOwner() {
    return this.resolverService.userInitInfo.merchant_detail.owner;
  }

  get userHasPin() {
    return this.resolverService.userInitInfo.merchant_detail.has_pin;
  }

  get companyPhysical() {
    return !this.resolverService.userInitInfo.company_permission.find(permission => permission.permission_type == PermissionType.physical && permission.action == PermissionView.exclude)
  }
  
  get companyDigital() {
    return !this.resolverService.userInitInfo.company_permission.find(permission => permission.permission_type == PermissionType.digital && permission.action == PermissionView.exclude)
  }
  
  get companyCrypto() {
    return !this.resolverService.userInitInfo.company_permission.find(permission => permission.permission_type == PermissionType.crypto && permission.action == PermissionView.exclude)
  }

  get isSysAdmin() {
    return this.resolverService.userInitInfo.profile.role.role_id == environment.role_types.admin;
  }
}
